import React, { useMemo } from 'react'

import {
  string,
  array,
  bool,
  func,
  number,
} from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

import { NOOP } from 'Utils/stableDefaults'

import CollapsibleSection from '../CollapsibleSection'
import AdultContentCheckbox from './Components/AdultContentCheckbox'
import ImagesList from './Components/ImagesList'

function ImagesArea({
  itemId,
  itemStatus,
  images,
  sortVersion = 0,
  removedImageIds,
  updateImageAdultAttr,
  handleDetailChange,
  isAdultContent,
  showErrors,
  onChange,
  onDragStateChange = NOOP,
  parentalLocked = false,
  onUploadClick = NOOP,
}) {
  const customUploadButton = useMemo(() => {
    return (
      <div
        className="images-section__header"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={onUploadClick}
        >
          <Icon type={['far', 'upload']} className="mr-5" />
          Upload Images
        </button>
      </div>
    )
  }, [onUploadClick])

  return (
    <div className="publisher-area publisher-area--images">
      <div className="card">
        <CollapsibleSection
          sectionSlug="images"
          trigger="Preview images"
          hasTooltip
          button={customUploadButton}
        >
          <div className="images-section">
            {images.length === 0 ? (
              <div
                className={`empty-images ${showErrors ? 'text-warning' : ''}`}
              >
                Please upload at least one preview image.
              </div>
            ) : (
              <div className="images-list">
                <AdultContentCheckbox
                  isChecked={isAdultContent}
                  handleDetailChange={handleDetailChange}
                  parentalLocked={parentalLocked}
                />

                <ImagesList
                  key={`${images.length}-${sortVersion}-images-list`}
                  itemId={itemId}
                  itemStatus={itemStatus}
                  images={images}
                  removedImageIds={removedImageIds}
                  updateImageAdultAttr={updateImageAdultAttr}
                  onChange={onChange}
                  onDragStateChange={onDragStateChange}
                  isAdultContentChecked={isAdultContent}
                />
              </div>
            )}
          </div>
        </CollapsibleSection>
      </div>
    </div>
  )
}

ImagesArea.propTypes = {
  itemId: string.isRequired,
  itemStatus: string.isRequired,
  images: array.isRequired,
  sortVersion: number,
  removedImageIds: array.isRequired,
  updateImageAdultAttr: func.isRequired,
  handleDetailChange: func.isRequired,
  isAdultContent: bool.isRequired,
  showErrors: bool.isRequired,
  onChange: func.isRequired,
  onDragStateChange: func,
  parentalLocked: bool,
  onUploadClick: func,
}

export default ImagesArea
